import { render } from "./MultisidebarHeaderActions.vue?vue&type=template&id=86c0fb7c&ts=true"
import script from "./MultisidebarHeaderActions.vue?vue&type=script&lang=ts"
export * from "./MultisidebarHeaderActions.vue?vue&type=script&lang=ts"

import "./MultisidebarHeaderActions.vue?vue&type=style&index=0&id=86c0fb7c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__